import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteGroup, deleteGroupAdmin } from "../../../axios/Group/GroupUrlApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const DeleteUserGroupDialog = ({
  open,
  handleClose,
  handleRefreshTable,
  info,
  adminGroup,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleRemove = async () => {
    setLoading(true);
    try {
      if (adminGroup && adminGroup.length > 0) {
        await Promise.all(
          adminGroup.map((admin) =>
            deleteGroupAdmin({
              userId: admin.userId,
              group: info?.id,
              langId: localStorage.getItem("i18nextLngId"),
            })
          )
        );
      }

      const payload = {
        group: info?.id,
        langId: localStorage.getItem("i18nextLngId"),
      };

      const response = await deleteGroup(payload);

      if (response?.data === "") {
        handleClose();
        toast.success(t("common.delete-group-successfully"));
        handleRefreshTable();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error("Failed to delete group or admins");
    } finally {
      setLoading(false);
    }
  };

  const onCloseDialog = () => {
    if (loading) return;
    handleClose();
  };

  return (
    <ConfirmActionDialog
      open={open}
      variant="delete"
      title={t("common.delete-this-user-group")}
      subtitle={t("common.are-you-sure-you-want-to-delete-user-group", {
        groupName: info?.groupName || "",
      })}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={onCloseDialog}
      onConfirm={handleRemove}
    />
  );
};

export default DeleteUserGroupDialog;
